
function _deepCmp(obj1, obj2, cmp){
  if(obj1 === obj2){
    return true;
  }
  if(obj1 === null || obj2 === null){
    return false;
  }
  let objType = typeof(obj1);
  if(objType !== typeof(obj2)){
    return false;
  }
  if(objType === 'object'){
    if(Array.isArray(obj1) !== Array.isArray(obj2)){
      return false;
    }else if(Array.isArray(obj1)){
      if(obj1.length !== obj2.length){
        return false;
      }
      for(let i=0; i<obj1.length; i++){
        if(!cmp(obj1[i], obj2[i], cmp)){
          return false;
        }
      }
      return true;
    }else{
      if(Object.keys(obj1).length !== Object.keys(obj2).length){
        return false;
      }
      for(let key in obj1){
        if(!obj2.hasOwnProperty(key)){
          return false;
        }else if(!cmp(obj1[key], obj2[key], cmp)){
          return false;
        }
      }
      return true;
    }
  }
  return obj1 === obj2;
}

export function deepCmp(obj1, obj2){
  return _deepCmp(obj1, obj2, _deepCmp);
}

export function deepCmpLog(obj1, obj2){
  let ret = _deepCmp(obj1, obj2, deepCmpLog);
  if(!ret) console.log("ret", obj1, obj2, ret);
  return ret;
}

export function deepMerge(src, dest) {
  let merged = {...dest};
  for(let key in src){
    let val = src[key];
    if(typeof(val) === 'object' && !Array.isArray(val)){
      merged[key] = deepMerge(val, merged[key])
    }else{
      merged[key] = val;
    }
  }
  return merged;
}

export function deepCmpLeft(obj1, obj2){
  if(obj1 === obj2){
    return true;
  }
  if(obj1 === null || obj2 === null){
    return true;
  }
  let objType = typeof(obj1);
  if(objType !== typeof(obj2)){
    return false;
  }
  if(objType === 'object'){
    if(Array.isArray(obj1) !== Array.isArray(obj2)){
      return false;
    }else if(Array.isArray(obj1)){
      if(obj1.length !== obj2.length){
        return false;
      }
      for(let i=0; i<obj1.length; i++){
        if(!deepCmpLeft(obj1[i], obj2[i])){
          return false;
        }
      }
      return true;
    }else{
      for(let key in obj1){
        if(obj2.hasOwnProperty(key)) {
          if (!deepCmpLeft(obj1[key], obj2[key])) {
            return false;
          }
        }
      }
      return true;
    }
  }
  return obj1 === obj2;
}

export function diffLeft(obj1, obj2){
  if(obj1 === obj2){
    return null;
  }
  if(obj1 === null || obj2 === null){
    return obj1;
  }
  let objType = typeof(obj1);
  if(objType !== typeof(obj2)){
    return obj1;
  }
  if(objType === 'object'){
    if(Array.isArray(obj1) !== Array.isArray(obj2)){
      return obj1;
    }else if(Array.isArray(obj1)){
      if(obj1.length === 0){
        return null;
      }
      return deepCmp(obj1, obj2) ? null : obj1;
    }else{
      let diff = {}
      let noDiff = true;
      for(let key in obj1){
        if(obj2.hasOwnProperty(key)) {
          let objDiff = diffLeft(obj1[key], obj2[key]);
          if (objDiff !== null) {
            if(typeof(objDiff) === "object" && Object.keys(objDiff).length === 0){
              continue;
            }
            diff[key] = objDiff;
            noDiff = false;
          }
        }
      }
      return noDiff ? null : diff;
    }
  }
  return obj1;
}